import { useSelector } from 'react-redux';
import { RootState } from 'store/index';
import { verifyChallengeKeeper, isKeeperActive as isMaxHit, verifyExtendMyLimit } from 'utils/keeper.utils';
import { Keeper, PropChallenge, PropPlan } from 'services/generatedClientFromSwagger';
import { useMemo } from 'react';

export const useEnableKeeperButton = ({ planId, challengeId }: { planId: string; challengeId: string }) => {
    const {
        selectedKeeperChallenge,
        selectedKeeperPlan,
    }: { selectedKeeperChallenge: PropChallenge; selectedKeeperPlan: PropPlan } = useSelector((state: RootState) => {
        const selectedKeeperPlan = state?.prop_myPlans.plans?.find((plan) => plan?.pPlan?.planId === planId);
        const selectedKeeperChallenge = selectedKeeperPlan?.propChallenges?.find(
            (challenge) => challenge?.id === challengeId
        );
        return { selectedKeeperChallenge, selectedKeeperPlan };
    });

    const isKeeperActive = verifyChallengeKeeper(selectedKeeperChallenge);
    const isMaxDailyHit = isMaxHit(selectedKeeperChallenge?.keeper?.maxDaily);
    const isMaxTotalHit = isMaxHit(selectedKeeperChallenge?.keeper?.maxTotal);

    const displayExtendMyLimit = verifyExtendMyLimit(selectedKeeperChallenge);

    const { keeperActiveTypes }: { keeperActiveTypes: (keyof Keeper)[] } = useMemo(() => {
        const keeperActiveTypes: (keyof Keeper)[] = [];

        if (isKeeperActive && isMaxDailyHit) {
            keeperActiveTypes.push('maxDaily');
        }
        if (isKeeperActive && isMaxTotalHit) {
            keeperActiveTypes.push('maxTotal');
        }

        return { keeperActiveTypes };
    }, [isMaxDailyHit, isMaxTotalHit]);

    return {
        selectedKeeperPlan,
        selectedKeeperChallenge,
        isKeeperActive,
        keeperActiveTypes,
        displayExtendMyLimit,
    };
};
